import { NgModule } from '@angular/core';
import { RecaptchaComponent } from './recaptcha.component';
import { CoreModule } from 'src/core/modules/core.Module';

@NgModule({
  declarations: [RecaptchaComponent],
  exports:[RecaptchaComponent],
  imports: [
    CoreModule
  ]
})
export class RecaptchaModule { }
